module.exports = __webpack_public_path__ + "img/freestyle_box17.b7521e83.jpg";